import type { CrmIntegrationProvider } from "./provider";

export const crmListObjectType = {
    accounts: "accounts",
    leads: "leads",
    contacts: "contacts",
} as const;
export type CrmListObjectType = keyof typeof crmListObjectType;

export type BaseCrmIntegrationObject = {
    readonly integrationName: CrmIntegrationProvider;
    readonly objectType: CrmListObjectType;
};
